import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../../config/apiConfig";

const deleteBlog = async (blogId) => {
  try {
    const { data } = await axiosInstance.delete(`/Blog/${blogId}`);
    return data;
  } catch (error) {
    console.error("Error deleting blog:", error);
    throw error;
  }
};

const useDeleteBlog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteBlog,
    onSuccess: () => {
      queryClient.invalidateQueries(["blogs"]);
    },
    onError: (err) => {
      console.error("Delete blog mutation failed:", err);
    },
  });
};

export default useDeleteBlog;

